import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './Responsive.css';

import ScrollToTop from './constants/scrollToTop';

import Header from './partials/Header';
import Home from './components/Home/Index';
import Result from './components/Game/Result';
import Game from './components/Game/Game';
import LOADING from './constants/Loading';

import Store from './contexts/reducer/store';

const App = () => {

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setInterval(() => {
      setLoading(false)
    }, 3000)
  },[]);

  return (
    <Store>
      <Router>
        {
          loading === true
            ? <LOADING/>
            : ''
        }
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Home />} />
          <Route path="/game" element={<Game/>} />
          <Route path="/result" element={<Result />} />
          <Route path="*" element={<NotFound/>} />
        </Routes>
      </Router>
    </Store>
  );
}

const NotFound = () => {
  return (
    <>
      <div className="loading">
        <Container className="h-100">
          <Row className="h-100">
            <Col className="text-center my-auto">
              <h1 className="text-white fredoka-one not-found">404</h1>
              <h4 className="text-white fredoka-one">Maaf halaman yang kamu cari tidak ada</h4>
              <Link to="/" className="btn btn-danger btn-lg fredoka-one mt-5">Kembali Ke Halaman Utama</Link>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default App;
